import {
  INVOICE_STATUS_LABELS,
  type InvoiceStatus,
} from '@/modules/billing/types';

const STATUS_CLASS: Record<InvoiceStatus, string> = {
  draft: 'billing-badge--draft',
  pending: 'billing-badge--pending',
  issued: 'billing-badge--issued',
  cancelled: 'billing-badge--cancelled',
  error: 'billing-badge--error',
};

type InvoiceStatusBadgeProps = {
  status: InvoiceStatus;
};

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  return (
    <span className={`billing-badge ${STATUS_CLASS[status]}`}>
      {INVOICE_STATUS_LABELS[status]}
    </span>
  );
}
